import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { MockInterceptor } from './interceptors/mock.interceptor';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      multi: true,
      provide: HTTP_INTERCEPTORS,
      useClass: MockInterceptor,
    },
  ],
})
export class MockModule {}
